const postMsg = (target, values) => {
  const targetContent = target.contentWindow
  const dataType = values.errorCode ? 'trigger_validate_iframe' : 'trigger_payment_iframe'
  const msg = JSON.stringify({
    dataSource: 'new-creditcard-form',
    dataSourceUrl: target.src,
    dataType,
    dataContent: {
      billingInfo: {
        ...values,
      },
    },
  })
  targetContent && targetContent.postMessage(msg, '*')
}

const resizeIframeHeight = (targetFrame, dataContent) => {
  if (targetFrame && dataContent && dataContent.height) {
    targetFrame.height = dataContent.height // eslint-disable-line
  }
}

const handleMsg = (e, targetFrame, callBack, billingInfo) => {
  const data = JSON.parse(e.data)
  if (data.dataSource === 'payment-method-service') {
    if (data.dataType === 'height_adjustment') {
      resizeIframeHeight(targetFrame, data.dataContent)
    } else if (data.dataType === 'trigger_payment_iframe' && billingInfo.errorCode !== 'BILLINGADDRESS_INVALID_PARAMS') {
      const params = { ...billingInfo, ...data.dataContent }
      callBack(params)
    }
  }
}

export {
  postMsg,
  handleMsg,
}
